module.exports = __webpack_public_path__ + "media/images/hero/hero2-person-corner-right-ffcc7e77f34915ca1c7460c97b0b2aca.svg";